import * as React from 'react'
import useAccount from '../useAccount'
import * as t from '../types'
import * as utils from '../utils'
import { GetSalutationsResponse } from '../response-types/get-salutations'
import config from 'config'

/**
 * fetches a list of salutations
 */
export default function useSalutationList() {
  const account = useAccount()
  const [list, setList] = React.useState(account._.stores.salutationList || [])
  const [fetching, setFetching] = React.useState(
    !account._.stores.salutationList
  )
  const labelDict = React.useMemo(() => {
    const dict: Record<string, string> = {}
    for (const row of list) dict[row.id] = row.label
    return dict
  }, [list])

  const fetch = async () => {
    if (config.modules.shopware.salutations.length === 0) {
      return
    }
    setFetching(true)
    const promise = account._.stores.salutationListP || fetchSalutationList()
    account._.stores.salutationListP = promise
    const result = await promise

    if (result.status === 200) {
      // todo:
      account._.stores.salutationList = result.payload
      setList(result.payload)
    }

    setFetching(false)
    delete account._.stores.salutationListP
  }

  React.useEffect(() => {
    if (list.length) return
    if (config.modules.shopware.salutations.length === 0) {
      setFetching(false)
      return
    }
    fetch().catch(() => {
      setFetching(false)
    })
  }, [])

  return {
    data: list,
    fetching,
    getLabel: (id: string) => labelDict[id] || ''
  }
}

/** @firescoutMockFn account.fetchSalutationList */
async function fetchSalutationList(): t.Response<t.Salutation[]> {
  try {
    const [result, status] =
      await utils.fetchFromShopware<GetSalutationsResponse>({
        method: 'POST',
        url: '/salutation',
        body: {
          filter: [
            {
              type: 'equalsAny',
              field: 'salutationKey',
              value: config.modules.shopware.salutations || []
            }
          ]
        }
      })

    if (status >= 400) {
      throw new Error('FETCH_SALUTAIONS_FAILED')
    }

    return {
      status: 200,
      payload: result.elements.map((row) => ({
        id: row._uniqueIdentifier || row.id,
        label: row.translated.displayName
      }))
    }
  } catch (e: any) {
    return { status: 500, payload: e }
  }
}
